import { NumberSymbol } from "@angular/common";
import { NumberValueAccessor } from "@angular/forms";

export class TestigoModel {
    id:number;
    valorGlobal:number;
    fechaAnalisis:number;
    tipoTestigoId:number;
    tipologia:number;
    supTotal:number;
    valorUnitario:number;
    anioConstr:number;
    direccion:string;
    tlfContacto:string;
    testigoEstadoId:number;
    pondB:number;
    areaB:number;
    precioB:number;
    pondT:number;
    areaT:number;
    precioT:number;
    tipoGaraje:number;
    nPlazas:number;
    precioG:number;
    latitude:number;
    longitude:number;
    localizacionTestigoId:number;
    letra:string;

    public constructor() {
        this.id = null;
        this.valorGlobal = null;
        this.fechaAnalisis = null;
        this.tipoTestigoId = null;
        this.tipologia = null;
        this.supTotal = null;
        this.valorUnitario = null;
        this.anioConstr = null;
        this.direccion = null;
        this.tlfContacto = null;
        this.testigoEstadoId  = null;
        this.pondB = null;
        this.areaB = null;
        this.precioB = null;
        this.pondT = null;
        this.areaT = null;
        this.precioT = null;
        this.tipoGaraje = null;
        this.nPlazas = null;
        this.precioG = null;
        this.latitude = null;
        this.longitude = null;
        this.localizacionTestigoId = null;
        this.letra = '';
    }
}
